import { addDisposer, types } from 'mobx-state-tree';
import { autorun } from 'mobx';
import { RouteCollection } from './RouteCollection';
import { history } from './RouteHistory';
export const Router = types.model({
  currentUrl: types.optional(types.string, ''),
  baseUrl: types.string,
  currentView: types.optional(types.string, ''),
  routes: types.frozen()
}).views(self => ({
  get router() {
    return new RouteCollection(self.routes);
  },
  getParameters() {
    return this.router.getArgsForView(self.currentUrl);
  }
})).actions(self => ({
  setCurrentUrl(url) {
    self.currentUrl = url;
  },
  setCurrentView(view) {
    let args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (view === self.currentView && Object.keys(args).length === 0) {
      return;
    }
    const url = self.router.getUrlForView(view, args);
    this.setCurrentUrl(`${self.baseUrl}${url}`);
  },
  setViewNameInternal(view) {
    self.currentView = view;
  },
  afterCreate() {
    autorun(() => {
      if (!self.currentUrl || self.currentUrl.length === 0) {
        this.setViewNameInternal('');
      }
      if (self.currentUrl !== history.location.pathname) {
        history.push(self.currentUrl);
      }
      const newView = self.router.getViewForUrl(self.currentUrl);
      this.setViewNameInternal(newView);
    });
    addDisposer(self, history.listen(location => this.setCurrentUrl(location.pathname)));
    this.setCurrentUrl(history.location.pathname);
  }
}));
export function createRouter(routes) {
  let baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return {
    baseUrl,
    routes
  };
}
//# sourceMappingURL=Router.js.map